import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';

import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  ColorBusinessActionsUnion,
  ColorBusinessActionTypes
} from '@core/actions/color-bussiness.actions';
import { ColorBusiness } from '@app/models/color-business';

export interface State extends EntityState<ColorBusiness> {
  loading: boolean;
  loaded: boolean;
  spinnerMessage: any;
}

export const adapter: EntityAdapter<ColorBusiness> = createEntityAdapter<
  ColorBusiness
>({
  selectId: (colorBusiness: ColorBusiness) => colorBusiness.id
});

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  spinnerMessage: null
});

export function reducer(
  state: State = INITIAL_STATE,
  action: ColorBusinessActionsUnion
) {
  switch (action.type) {
    case ColorBusinessActionTypes.Load:
      return { ...state, loading: true };

    case ColorBusinessActionTypes.LoadFail:
      return { ...state, loading: false };

    case ColorBusinessActionTypes.LoadSuccess:
      return adapter.addAll(action.colorBusiness, {
        ...state,
        loading: false,
        loaded: true
      });

    case ColorBusinessActionTypes.AddOne:
      return adapter.addOne(action.colorBusiness, state);

    case ColorBusinessActionTypes.AddAll:
      return adapter.addAll(action.colorBusiness, state);

    case ColorBusinessActionTypes.Create:
      return { ...state, loading: true };

    case ColorBusinessActionTypes.CreateFail:
    case ColorBusinessActionTypes.CreateSuccess:
      return { ...state, loading: false };

    case ColorBusinessActionTypes.UpdateOne:
      return adapter.updateOne(
        { id: action.colorBusiness.id, changes: action.colorBusiness },
        state
      );

    case ColorBusinessActionTypes.Update:
      return {
        ...state,
        loading: true,
        spinnerMessage: 'Actualizando'
      };

    case ColorBusinessActionTypes.UpdateSuccess:
      return {
        ...state,
        loading: false,
        spinnerMessage: 'Actualizacion Correcta'
      };
    case ColorBusinessActionTypes.UpdateFail:
      return {
        ...state,
        loading: false,
        spinnerMessage: 'Actualizacion Fallida'
      };

    case ColorBusinessActionTypes.Delete:
      return {
        ...state,
        loading: true,
        spinnerMessage: 'Eliminando color'
      };

    case ColorBusinessActionTypes.DeleteSuccess:
      return {
        ...state,
        loading: false,
        spinnerMessage: 'Color Eliminado Correctamente'
      };

    // case ColorBusinessActionTypes.DeleteFail:
    // return {
    //     ...state,
    //     loading: false,
    //     spinnerMessage: ''
    // };

    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();

export const selectLoaded = (state: State) => state.loaded;
export const selectLoading = (state: State) => state.loading;
export const selectSpinnerMessage = (state: State) => state.spinnerMessage;

export const getState = createFeatureSelector<State>('colorBussinesses');
export const getColorBussiness = createSelector(
  getState,
  selectAll
);
